import {apiGet, apiPostWithRetry} from './client';

export function createSubscription({accountId, planId, yandexClientId}) {
    return apiPostWithRetry('/celebs/subscribe', {
        account_id: accountId,
        plan_id: planId,
        yandex_client_id: yandexClientId || undefined,
    });
}

export function cancelSubscription({accountId}) {
    return apiPostWithRetry('/celebs/subscription/cancel', {
        account_id: accountId,
    });
}

export function removeAttachedCard({accountId}) {
    return apiPostWithRetry('/celebs/subscription/remove-card', {
        account_id: accountId,
    });
}

export function getSubscription(accountId) {
    return apiGet(`/celebs/subscription?account_id=${encodeURIComponent(accountId)}`);
}

export function createTopup({accountId, planId, yandexClientId}) {
    return apiPostWithRetry('/celebs/topup', {
        account_id: accountId,
        plan_id: planId,
        yandex_client_id: yandexClientId || undefined,
    });
}
